import React from "react";
import PricingTable from "./PricingTable";

const SubscriptionView = ({ email, onGoBack, currentSubscription = null }) => {
  return (
    <div>
      <button className="go-back-button" onClick={onGoBack}>
        ← Back
      </button>
      <PricingTable currentSubscription={currentSubscription} email={email} />
    </div>
  );
};

export default SubscriptionView;
